import { create } from "zustand";

interface WorldStore {
  selectedTopologyId: string | null;
  selectedRunId: string | null;
  mode: "design" | "monitor";
  viewMode: "flow" | "pixel";
  /** Whether the pixel-world canvas is in full-screen presentation mode. */
  fullscreen: boolean;
  /** Whether the topology template gallery is open. */
  templateGalleryOpen: boolean;

  selectTopology: (id: string | null) => void;
  selectRun: (id: string | null) => void;
  setMode: (mode: "design" | "monitor") => void;
  setViewMode: (viewMode: "flow" | "pixel") => void;
  setFullscreen: (fullscreen: boolean) => void;
  toggleFullscreen: () => void;
  setTemplateGalleryOpen: (open: boolean) => void;
}

export const useWorldStore = create<WorldStore>((set) => ({
  selectedTopologyId: null,
  selectedRunId: null,
  mode: "monitor",
  viewMode: "flow",
  fullscreen: false,
  templateGalleryOpen: false,

  selectTopology: (id) => set({ selectedTopologyId: id, selectedRunId: null }),
  selectRun: (id) => set({ selectedRunId: id }),
  setMode: (mode) => set({ mode }),
  setViewMode: (viewMode) => set({ viewMode }),
  setFullscreen: (fullscreen) => set({ fullscreen }),
  toggleFullscreen: () => set((s) => ({ fullscreen: !s.fullscreen })),
  setTemplateGalleryOpen: (open) => set({ templateGalleryOpen: open }),
}));
